import React, { useContext, useEffect, useRef } from 'react';
// import Navbar from './components/Navbar';
import Hero from './components/Hero';
import OrderSupply from './components/OrderSupply';
import Partners from './components/Partners';
import Testimonials from './components/Testimonials';
import RevenueModel from './components/RevenueModel';
import ServiceSupport from './components/ServiceSupport';
import Process from './components/Process';
import About from './components/About';
import { detectDevice } from '@/utils';
import { DataContext } from '@/context';
import Header from '@/components/Header';
import { RenderFooter } from '../RenderFooter';
import useAnchorScroll from '@/hooks/useAnchorScroll';

interface Props {
  userOtherInfo: any;
  payCountObj: any;
}

const CommercialOrder: React.FC<Props> = (props: Props) => {
  const { userOtherInfo } = props;
  const childRef = useRef<any>(null);
  const isPc = detectDevice()

  const {
    userInfo,
    setContextValue
  } = useContext(DataContext);

  return (
    <div className="bg-black min-h-screen text-white selection:bg-blue-500/30">
      {/* <Navbar /> */}
      <Header ref={childRef} {...props} />
      <main className='min-w-[1310px]'>
        <Hero childRef={childRef} openLogin={childRef?.current?.openLogin} />
        <OrderSupply />
        <Partners />
        <Testimonials />
        <RevenueModel />
        <ServiceSupport childRef={childRef} />
        <Process childRef={childRef} />
        <About />
        <RenderFooter />
      </main>
    </div>
  );
};

export default CommercialOrder;